export const Territories = ["ZBM", "RBM", "ABM", "TSO"];
export const TerritoryIDs: any = {
  ZBM: 6,
  RBM: 5,
  ABM: 4,
  TSO: 3,
};